import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import Level from './Level';
import { Link } from 'react-router-dom';

function LevelList(props) {
  const { levels } = props;
  const { firestore } = props;
  const refModal2 = React.createRef();
  const [selectedLevel, setSelectedLevel] = useState('');
  const [selectedLevelId, setLevelId] = useState('');

  const initLoading = () => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(initLoading, []);

  const onDelete = (levelId, level) => {
    const modal = M.Modal.getInstance(refModal2.current);
    modal.open();
    setLevelId(levelId);
    setSelectedLevel(level);
  };

  const deleteSelectedLevel = () => {
    firestore
      .collection('levels')
      .doc(selectedLevelId)
      .delete()
      .then((response) => {
        console.log('Delete Level completed', response);
        return true;
      })
      .catch((error) => {
        console.warn('Delete Level Failed', error);
        return false;
      });
  };

  const renderDeleteDialog = () => {
    return (
      <div ref={refModal2} id="modalQuestion" className="modal">
        <div className="modal-content">
          <h5>Are you sure to delete "{selectedLevel}" level?</h5>
        </div>
        <div className="modal-footer">
          <a href="#deleteLevel" onClick={(e) => deleteSelectedLevel()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="company-list section">
      <div className="title-section">Levels</div>
      <div className="row center container-center">
        <div className="col s3 title-section">Add MultiLevels</div>
        <Link className="btn-large green right" to="newLevels">
          add
        </Link>
      </div>
      <div className="row center container-center">
        <div className="col s8 title-section">Edit Levels Config</div>
        <Link className="btn-large green right" to="levelsConfig">
          Edit
        </Link>
      </div>
      {renderDeleteDialog()}
      {levels.map((level, index) => {
        return <Level key={level.id} level={level} showDelete={index + 1 === levels.length} onDelete={onDelete} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(LevelList);
